import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    homePageWrapper: {
        fontSize: '0.8rem',
        margin: "15px",
        '& .active-navigation-cell' :{
            border : "2px solid rgb(25 214 91) !important"
        }
    },
    tableHeaderColumn: {
        backgroundColor: '#7f9ed7',
        color: 'white'
    },
    advanceSeachWrapper: {
        background: '#f8f9fa',
        boxShadow: 'inset 0rem 0rem 0.25rem rgb(0 0 0 / 8%)',
        marginBottom: '9px'
    },
    tableBody: {

        '& tr:nth-of-type(odd)': {
            backgroundColor: '#cfd5ea !important'
        },
        '& td': {
            padding: '0.5rem 0rem 0.5rem 0.5rem',
            fontSize: '0.7rem'
        },
        '& tr': {
            backgroundColor: '#e9ebf5'
        }
    },
    headerTitle: {
        textAlign: "center",
        flexGrow: 1,
        fontWeight: "bold",
        marginTop: '10px'
    },
    title: {
        textAlign: "center",
        flexGrow: 1,
        fontWeight: "bold",
        // marginTop: '-25px'
    },
    toolbar: {
        maxHeight: '36px',
        minHeight: '36px',
        "& .selectStyle": {
            padding: '0.5px',
            height: '27px',
            marginTop: '4px',
            fontSize: '0.8rem'
        },
        "& .iconadvSearch svg": {
            fontSize: '20px',
        }
    },
    requestsCount: {
        marginTop: '20px',
        marginBottom: '20px',
        borderRadius: '12px',
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        overflow: 'hidden',
    }
}));